import { getSimCardUpsellPrimaryDataLabel } from "./sim-card-upsell-plan-options";

export const INCLUDED_PRIMARY_DATA_FEATURES = [
  "Unlimited calls in the U.S.",
  "Keep Your Existing Phone Number",
  "1GB of Data Per Month",
  "Free Calls to 170+ Countries",
  "Free Roaming in Canada & Mexico",
  "Nationwide Coverage",
  "Cancel anytime",
];

export function serviceCoverageFeatureLine(frequencyKey: string): string {
  switch (frequencyKey) {
    case "monthly":
      return "Covers 1 month of service";
    case "threeMonths":
      return "Covers 3 months of service";
    case "sixMonths":
      return "Covers 6 months of service";
    case "twelveMonths":
      return "Covers 12 months of service";
    default:
      return "Covers your selected billing period";
  }
}

export function upgradeCardTitle(primaryKey: string, frequencyKey: string): string {
  const data = getSimCardUpsellPrimaryDataLabel(primaryKey);
  const period =
    frequencyKey === "monthly"
      ? "1 Mo"
      : frequencyKey === "threeMonths"
      ? "3 Mo"
      : frequencyKey === "sixMonths"
      ? "6 Mo"
      : frequencyKey === "twelveMonths"
      ? "12 Mo"
      : "";
  return period ? `Upgrade to ${data}/${period}` : `Upgrade to ${data}`;
}
